import React from "react";
import "./styles.scss";

// Images from public folder
const backgroundImage = "/2025/atletica/images/background.svg";
const logoImage = "/2025/atletica/images/logo.png";
const rightPhoneImage = "/2025/atletica/images/rightPhone.png";

// Video and phone frame overlays
const atleticaVideo = "/2025/atletica/video/atletica.mp4";
const topBarImage = "/2025/atletica/video/attributes/topBar.png";
const bottomFrameImage = "/2025/atletica/video/attributes/bottomFrame.png";

// Icons
const googleIcon = "/2025/atletica/icons/google.svg";
const appleIcon = "/2025/atletica/icons/apple.svg";

export function Atletica() {
  return (
    <section className="atletica-section">
      {/* Background */}
      <div className="atletica-background">
        <img src={backgroundImage} alt="" />
      </div>

      {/* Content Container */}
      <div className="atletica-container">
        {/* Left Side - Text Content */}
        <div className="atletica-content">
          {/* Logo */}
          <div className="atletica-logo">
            <img src={logoImage} alt="Atletica" />
          </div>

          {/* Description */}
          <div className="atletica-description">
            <p>
              Най-новото мобилно приложение от нашата фабрика за иновативни решения! Като водещ производител на фитнес оборудване в Германия, с Atletica започваме 2026-та година с нова дигитална платформа за уникални по рода си преживявания в дигитална среда.
            </p>
          </div>

          {/* App Store Buttons */}
          <div className="atletica-buttons">
            <a href="#" className="store-button">
              <img src={googleIcon} className="store-button" alt="Get it on Google Play" />
            </a>
            <a href="#" className="store-button">
              <img src={appleIcon} className="store-button" alt="Download on the App Store" />
            </a>
          </div>
        </div>

        {/* Right Side - Phone Mockups */}
        <div className="atletica-phones">
          <div className="phone-left">
            <video 
              className="phone-video"
              src={atleticaVideo}
              autoPlay
              loop
              muted
              playsInline
            />
            <img src={topBarImage} alt="" className="phone-frame-top" />
            <img src={bottomFrameImage} alt="" className="phone-frame-bottom" />
          </div>
          <div className="phone-right">
            <img src={rightPhoneImage} alt="Atletica Training Plan" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
}
